import { Navigate, useNavigate } from 'react-router-dom'
import { OnboardingPage } from '../app/OnboardingPage'
import { useTenant } from '../tenancy/TenantProvider'
import { deferOnboardingForSession } from './onboarding-session'
import '../styles/onboarding-safe-exit.css'

const completedOnboardingStates = new Set(['baseline_complete', 'active', 'offboarding', 'retired'])

export function OnboardingSetupRoute() {
  const { current, loading, servicePermitted } = useTenant()
  const navigate = useNavigate()

  if (!loading && current && !servicePermitted) return <Navigate to="/" replace />

  const onboardingComplete = Boolean(
    current && completedOnboardingStates.has(current.organisation.onboardingStatus),
  )

  const exitIncompleteSetup = () => {
    if (!current) return

    deferOnboardingForSession(current.organisation.id, current.membershipId)
    void navigate('/', { replace: true })
  }

  return (
    <>
      <OnboardingPage />
      {current && !onboardingComplete ? (
        <div className="onboarding-safe-exit">
          <button className="button ghost" type="button" onClick={exitIncompleteSetup}>
            Exit setup
          </button>
          <span>Your completed steps are saved. You can return to setup later.</span>
        </div>
      ) : null}
    </>
  )
}
